// The University of Tulsa's undergraduate majors (#2743). Read on 2026-10-01
// from the official 2026-2027 Undergraduate Bulletin (bulletin.utulsa.edu,
// catoid=56): its All Programs page lists every major, and each college's page
// in the bulletin lists the majors that college offers, which sets the
// groups here (every major sits under exactly one college). Every line under
// "Major" is kept, options, tracks and emphases included, as the bulletin
// lists them; minors, certificates, accelerated and joint programs are left
// out. The online Accelerated and R.N. to B.S.N. nursing options are listed
// because the bulletin lists them as majors, though they are not first-year
// programs. Degree abbreviations are the bulletin's own; the student-designed
// concentration in Kendall College carries no degree in the bulletin, so it
// is null. The bulletin's curly apostrophe in "Women's and Gender Studies" is
// typed straight. The KB's majors list was the starting point; the bulletin
// wins.
const majors = {
    "slug": "university-of-tulsa",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in The University of Tulsa's official 2026-2027 Undergraduate Bulletin, grouped by the college that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Kendall College of Arts and Sciences",
            "source": {
                "label": "University of Tulsa 2026-2027 Undergraduate Bulletin, Kendall College of Arts and Sciences",
                "url": "https://bulletin.utulsa.edu/content.php?catoid=56&navoid=3058"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.S."
                },
                {
                    "name": "Art, Art History Specialization",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art, Studio Art Specialization",
                    "degree": "B.A."
                },
                {
                    "name": "Arts, Culture, and Entertainment (ACE) Management",
                    "degree": "B.A."
                },
                {
                    "name": "Composition",
                    "degree": "B.M."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Education, Art Education Option",
                    "degree": "B.A."
                },
                {
                    "name": "Education, English Option",
                    "degree": "B.A."
                },
                {
                    "name": "Education, French Education Option",
                    "degree": "B.A."
                },
                {
                    "name": "Education, German Education Option",
                    "degree": "B.A."
                },
                {
                    "name": "Education, Mathematics Option",
                    "degree": "B.A."
                },
                {
                    "name": "Education, Mathematics Option",
                    "degree": "B.S."
                },
                {
                    "name": "Education, Social Studies Education Option",
                    "degree": "B.A."
                },
                {
                    "name": "Education, Spanish Education Option",
                    "degree": "B.A."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.A."
                },
                {
                    "name": "English and Creative Writing",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Policy",
                    "degree": "B.S."
                },
                {
                    "name": "Film Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Media Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Music Education, Instrumental",
                    "degree": "B.M.E."
                },
                {
                    "name": "Music Education, Vocal",
                    "degree": "B.M.E."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Organizational Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Performance, Instrumental",
                    "degree": "B.M."
                },
                {
                    "name": "Performance, Piano",
                    "degree": "B.M."
                },
                {
                    "name": "Performance, Vocal",
                    "degree": "B.M."
                },
                {
                    "name": "Philosophy and Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.S."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Student-designed Area of Concentration, Kendall College of Arts and Sciences",
                    "degree": null
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Collins College of Business",
            "source": {
                "label": "University of Tulsa 2026-2027 Undergraduate Bulletin, Collins College of Business",
                "url": "https://bulletin.utulsa.edu/content.php?catoid=56&navoid=3071"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Business Information Systems",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Energy Business",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "International Business and Language",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "International Business and Language, American Track",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Management",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S.B.A."
                }
            ]
        },
        {
            "name": "College of Engineering and Computer Science",
            "source": {
                "label": "University of Tulsa 2026-2027 Undergraduate Bulletin, College of Engineering and Computer Science",
                "url": "https://bulletin.utulsa.edu/content.php?catoid=56&navoid=3061"
            },
            "majors": [
                {
                    "name": "Applied Artificial Intelligence, Chemical Engineering Track",
                    "degree": "B.S.A.A.I."
                },
                {
                    "name": "Applied Artificial Intelligence, Computer Engineering Track",
                    "degree": "B.S.A.A.I."
                },
                {
                    "name": "Applied Artificial Intelligence, Computer Science Track",
                    "degree": "B.S.A.A.I."
                },
                {
                    "name": "Applied Artificial Intelligence, Computer Simulation and Gaming Track",
                    "degree": "B.S.A.A.I."
                },
                {
                    "name": "Applied Artificial Intelligence, Cyber Security Track",
                    "degree": "B.S.A.A.I."
                },
                {
                    "name": "Applied Artificial Intelligence, Data Science Track",
                    "degree": "B.S.A.A.I."
                },
                {
                    "name": "Applied Artificial Intelligence, Electrical Engineering Track",
                    "degree": "B.S.A.A.I."
                },
                {
                    "name": "Applied Artificial Intelligence, Engineering Physics - Electrical Engineering Track",
                    "degree": "B.S.A.A.I."
                },
                {
                    "name": "Applied Artificial Intelligence, Engineering Physics - Mechanical Engineering Track",
                    "degree": "B.S.A.A.I."
                },
                {
                    "name": "Applied Artificial Intelligence, Mechanical Engineering Track",
                    "degree": "B.S.A.A.I."
                },
                {
                    "name": "Applied Data Science in Sports and Human Performance",
                    "degree": "B.S.A.D.S.S.H.P."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "B.S.A.M."
                },
                {
                    "name": "Chemical Engineering, General Option",
                    "degree": "B.S.Ch.E."
                },
                {
                    "name": "Chemical Engineering, Pre-medicine Option",
                    "degree": "B.S.Ch.E."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S.Com.E."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S.C.S."
                },
                {
                    "name": "Computer Simulation and Gaming",
                    "degree": "B.S.C.S.G."
                },
                {
                    "name": "Cyber Security",
                    "degree": "B.S.Cy.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S.D.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.E.E."
                },
                {
                    "name": "Engineering Physics, Bioengineering Option",
                    "degree": "B.S.E.P."
                },
                {
                    "name": "Engineering Physics, Electrical Engineering Option",
                    "degree": "B.S.E.P."
                },
                {
                    "name": "Engineering Physics, Mechanical Engineering Option",
                    "degree": "B.S.E.P."
                },
                {
                    "name": "Geosciences",
                    "degree": "B.S.G.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.M.E."
                },
                {
                    "name": "Petroleum Engineering",
                    "degree": "B.S.P.E."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Student-designed Area of Concentration, College of Engineering and Computer Science",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Oxley College of Health and Natural Sciences",
            "source": {
                "label": "University of Tulsa 2026-2027 Undergraduate Bulletin, Oxley College of Health and Natural Sciences",
                "url": "https://bulletin.utulsa.edu/content.php?catoid=56&navoid=3069"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "B.S.B."
                },
                {
                    "name": "Biochemistry, Pre-Med Option",
                    "degree": "B.S.B."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S.B.S."
                },
                {
                    "name": "Biology, Pre-Med Option",
                    "degree": "B.S.B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S.C."
                },
                {
                    "name": "Chemistry, Pre-Med Option",
                    "degree": "B.S.C."
                },
                {
                    "name": "Exercise and Sports Science",
                    "degree": "B.S.E.S.S."
                },
                {
                    "name": "Exercise and Sports Science, Pre-medicine Emphasis",
                    "degree": "B.S.E.S.S."
                },
                {
                    "name": "Exercise and Sports Science, Pre-professional Emphasis",
                    "degree": "B.S.E.S.S."
                },
                {
                    "name": "Integrative Healthcare Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                },
                {
                    "name": "Nursing, Accelerated Option (Online)",
                    "degree": "B.S.N."
                },
                {
                    "name": "Nursing, R.N. to B.S.N. Option (Online)",
                    "degree": "B.S.N."
                },
                {
                    "name": "Speech-language Pathology",
                    "degree": "B.S.S.P."
                },
                {
                    "name": "Student-designed Area of Concentration, Oxley College of Health and Natural Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Honors College",
            "source": {
                "label": "University of Tulsa 2026-2027 Undergraduate Bulletin, Honors College",
                "url": "https://bulletin.utulsa.edu/content.php?catoid=56&navoid=3084"
            },
            "majors": [
                {
                    "name": "Humane Letters",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
